import { ReactNode } from "react";

import styled from "@emotion/styled";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";

import { LIGHT_PURPLE, PURPLE } from "@/css/constants";

const defaultOptions = {
  loop: true,
  centeredSlides: true,
  modules: [Pagination, Autoplay],
  pagination: {
    clickable: true,
    bulletActiveClass: "active",
    bulletClass: "dot-button",
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  speed: 500,
};

export const DOTS_BAR_HEIGHT = 27;

interface CarouselProps {
  children: ReactNode[];
  options?: Record<string, unknown>;
  onInit?: (swiper: any) => void;
  onBeforeChange?: (oldIndex: number, newIndex: number) => void;
  onAfterChange?: (index: number) => void;
}

export default function Carousel({
  children,
  options,
  onInit,
  onBeforeChange,
  onAfterChange,
}: CarouselProps) {
  return (
    <CarouselContainer>
      <StyledSwiper
        {...defaultOptions}
        {...options}
        onSwiper={(swiperInstance) => {
          if (onInit) onInit(swiperInstance);
        }}
        onSlideChange={(swiperInstance) => {
          if (onAfterChange) {
            onAfterChange(swiperInstance.activeIndex);
          }
        }}
        onBeforeTransitionStart={(swiperInstance) => {
          if (onBeforeChange) {
            onBeforeChange(
              swiperInstance.previousIndex,
              swiperInstance.activeIndex,
            );
          }
        }}
      >
        {children.map((child, index) => (
          <SwiperSlide key={index}>{child}</SwiperSlide>
        ))}
      </StyledSwiper>
    </CarouselContainer>
  );
}

const CarouselContainer = styled.div`
  position: relative;
  padding-bottom: ${DOTS_BAR_HEIGHT}px;
`;

const StyledSwiper = styled(Swiper)`
  .dot-button {
    width: 11px;
    height: 11px;
    cursor: pointer;
    border: 0;
    padding: 0;
    margin: 0 4px;
    border-radius: 50%;
    background-color: ${LIGHT_PURPLE};
    transition: background-color 0.2s;
    opacity: 1;

    &.active {
      background-color: ${PURPLE};
    }

    &:hover {
      background-color: ${PURPLE};
    }
  }

  .swiper-pagination {
    bottom: -${DOTS_BAR_HEIGHT}px;
  }
`;
